import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class MatterMoodleIdsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      matter_moodle_ids: this.props.matter_moodle_ids,
      matter_id: this.props.matter_id,
      moodle_id: '',
      identification: '',
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionar = this.adicionar.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.matter_id !== 'undefined' && Array.isArray(newProps.matter_moodle_ids) && newProps.matter_moodle_ids.length > 0) {
      this.setState({matter_moodle_ids: newProps.matter_moodle_ids, matter_id: newProps.matter_id});
    }
  }

  adicionar(event) {
    event.preventDefault();
    var datasave = {
      matter_id: this.props.matter_id,
      moodle_id: this.state.moodle_id,
      identification: this.state.identification,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/moodle_id', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var matter_moodle_ids_temp = self.state.matter_moodle_ids;
          matter_moodle_ids_temp.push(responseJson.data);
          self.setState({
            matter_moodle_ids: matter_moodle_ids_temp,
            moodle_id: '',
            identification: '',
          });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var matter_moodle_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse registro?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/materia/moodle_id/' + matter_moodle_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(matter_moodle_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(matter_moodle_id) {
    var matter_moodle_ids_temp = this.state.matter_moodle_ids;
    matter_moodle_ids_temp.map(function(dado, index){
      if (dado.id == matter_moodle_id) {
        matter_moodle_ids_temp.splice(index, 1);
      }
    });
    this.setState({matter_moodle_ids: matter_moodle_ids_temp});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionar}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Identificação:</label>
          <input type="text" name="identification" className="form-control" placeholder="Identificação" value={this.state.identification} onChange={this.handleChange.bind(this, 'identification')} required />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Moodle ID:</label>
          <input type="number" name="moodle_id" className="form-control" placeholder="Moodle ID" value={this.state.moodle_id} onChange={this.handleChange.bind(this, 'moodle_id')} required />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.matter_moodle_ids} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há registros cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} hidden={true} dataField="id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='60'>ID</TableHeaderColumn>

    <TableHeaderColumn dataField="identification" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Identificação</TableHeaderColumn>
    <TableHeaderColumn dataField="moodle_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Moodle ID</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default MatterMoodleIdsTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/MatterMoodleIdsTab.js